import { environment } from 'src/environments/environment';

export const CURRENCY = '¥';

export const LINK_INSTAGRAM = 'https://www.instagram.com/buki.jp/';
export const LINK_ORDER_CONTACT = '/ordercontract/';

export const STRIPE_PUBLIC_KEY_TEST = 'pk_test_51HbeSXHbWEBrAyqZIQtWf2VTT9gRBg10xwWoaVn9HYSJhnUxcwy3v9UyDXMXVrSCexPWiPC0KD5RKzohOxMxgH1E00Ra6bMRAv';
export const STRIPE_PUBLIC_KEY_LIVE = 'pk_live_51HbeSXHbWEBrAyqZQjAVCysf1RHc1xVYkpnTsKxI0lxvjyURUuyLrSHAUR0o2cNz99lwKQe9i086TAwdYm2GX1xh00v4424a4D';

export const STRIPE_PUBLIC_KEY = environment.production ? STRIPE_PUBLIC_KEY_LIVE : STRIPE_PUBLIC_KEY_TEST;
export const API_URL = 'https://us-central1-buki-st12020.cloudfunctions.net/';

export const DB_SYSTEM = 'system';
export const DB_GIFTS = 'gifts';
export const DB_GIFT = 'gift';
export const DB_PARAMETERS = 'parameters';
export const DB_DISCOUNT_CAMPAIGNS = 'discountCampaigns';
export const DB_USERS = 'users';
export const DB_BOOKS = 'books';
export const DB_STRIPE_CUSTOMERS = 'stripe_customers';
export const DB_PAYMENTS = 'payments';
export const DB_PAYMENT_METHODS = 'payment_methods';
export const DB_ORDERS = 'orders';
export const DB_GIFT_ORDERS = 'giftOrders';
export const DB_COUPONS = 'coupons';
